import { makeStyles } from '@material-ui/core';

import { StyleProps } from './interface';

export const useStyles = makeStyles(() => ({
  supplierSelector: {
    width: '30%',
    marginTop: '20px',
    marginLeft: '20px',
    marginBottom: '20px'
  },
  loaderContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '80vh',
    margin: '24px'
  },
  loaderAssignor: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: (props: StyleProps) => ({
    display: 'flex',
    justifyContent: 'center',
    borderTop: '1px solid #ccc',
    width: 'auto',
    height: 'auto',
    backgroundColor: props.color === 'dark' ? '#333' : '#ffffff'
  }),
  emptyListContainer: {
    margin: '20px 20px 0px 20px',
    width: '100%'
  },
  content: {
    margin: '25px 1rem',
    maxWidth: '1000px'
  },
  formsContainer: {
    marginBottom: '20px'
  },
  assignorSessionHeader: {
    marginTop: '20px',
    marginBottom: '10px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  sessionBankDetails: {
    marginTop: '20px',
    marginBottom: '20px'
  },
  attentionHighlight: {
    '& .MuiInputLabel-root': {
      color: '#ffa000'
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: '#ffa000'
    },
    '& .asterisk': {
      color: '#ffa000'
    }
  },
  captionUnsavedData: {
    color: '#ff8f00'
  },
  buttons: {
    display: 'flex',
    gap: '10px'
  }
}));
